import axios from 'axios';
import * as types from './types';
import { loading, success, handleErrorException, error } from 'State/actions';

export const getGrades = siteIds => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      let response;
      const { Api, source } = MPWWebApi.createCancelableApi();
      dispatch(
        loading(types.ROSTER_BALANCE_REPORT_LOADING_GRADES, true, true, source)
      );
      response = await Api.postGenericInsertUpdate(
        `Grade/GetGradeListForSiteIds`,
        siteIds
      );
      dispatch(
        success(types.ROSTER_BALANCE_REPORT_GET_GRADES, response.data.Data)
      );
      dispatch(loading(types.ROSTER_BALANCE_REPORT_LOADING_GRADES, false));
    } catch (ex) {
      const defaultError = {
        Title: 'Error',
        Message: 'An error occurred while getting the data. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ROSTER_BALANCE_REPORT_ERRORS,
          defaultError
        )
      );
      if (!axios.isCancel(ex)) {
        dispatch(loading(types.ROSTER_BALANCE_REPORT_LOADING_GRADES, false));
      }
    }
  };
};

export const getTeachers = sites => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Student/TeachersBySites`,
        sites
      );
      dispatch(
        success(types.ROSTER_BALANCE_REPORT_GET_TEACHERS, response.data.Data)
      );
    } catch (ex) {
      const defaultError = {
        Title: 'Error',
        Message: 'An error occurred while getting the data. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ROSTER_BALANCE_REPORT_ERRORS,
          defaultError
        )
      );
    }
  };
};

export const getReport = (model, exportFileType) => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.ROSTER_BALANCE_REPORT_LOADING, true));
    try {
      const response = await MPWWebApi.postGenericInsertUpdate(
        `Reports/RosterBalanceReport`,
        model,
        exportFileType
      );
      dispatch({
        payload: response.data.Data ? response.data.Data : 'No Data',
        type: types.ROSTER_BALANCE_REPORT_GET_REPORT,
      });
    } catch (ex) {
      const defaultError = {
        Title: 'Error',
        Message: 'An error occurred while getting the data. Please try again',
      };
      dispatch(
        handleErrorException(
          ex,
          types.ROSTER_BALANCE_REPORT_ERRORS,
          defaultError
        )
      );
    }
    dispatch(loading(types.ROSTER_BALANCE_REPORT_LOADING, false));
  };
};

export const clearErrors = () => {
  return error(types.ROSTER_BALANCE_REPORT_ERRORS, []);
};

export const clearReport = () => {
  return {
    type: types.ROSTER_BALANCE_REPORT_GET_REPORT,
    payload: null,
  };
};

export const downloadReport = (model, formatType, fileName) => async (
  dispatch,
  getState,
  MPWWebApi
) => {
  dispatch(loading(types.ROSTER_BALANCE_REPORT_LOADING, true));
  try {
    const response = await MPWWebApi.postDownloadFile(
      'Reports/RosterBalanceReport',
      fileName,
      model,
      formatType
    );
    dispatch({
      payload: response ? response : 'No Data',
      type: types.ROSTER_BALANCE_REPORT_GET_REPORT,
    });
  } catch (ex) {
    const defaultError = {
      Title: 'Error',
      Message: 'An error occurred while getting the data. Please try again',
    };
    dispatch(
      handleErrorException(ex, types.ROSTER_BALANCE_REPORT_ERRORS, defaultError)
    );
  }
  dispatch(loading(types.ROSTER_BALANCE_REPORT_LOADING, false));
};



// WEBPACK FOOTER //
// ./src/pages/rostercurrentbalance/state/roster/actions.js